// Identifica links de VÍDEO do YouTube (watch/embed/shorts/youtu.be) dentro das
// citações do SmartChat — não links de canal (ex: youtube.com/@goliveconsultoria),
// usados no rodapé de "sem resposta" e que devem continuar abrindo em nova aba.
export const getYouTubeVideoUrl = (href) => {
  if (!href) return null;

  try {
    const url = new URL(href);
    const host = url.hostname.replace(/^www\./, '').replace(/^m\./, '');

    if (host === 'youtu.be' && url.pathname.length > 1) return href;

    if (host === 'youtube.com') {
      if (url.pathname === '/watch' && url.searchParams.get('v')) return href;
      if (url.pathname.startsWith('/embed/')) return href;
      if (url.pathname.startsWith('/shorts/')) return href;
    }

    return null;
  } catch (error) {
    return null;
  }
};
